"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InstantResultListRow = void 0;
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useDeliveryChannelAddressQuery = require("../../api/useDeliveryChannelAddressQuery");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _utils = require("../../utils");
var _HighlightText = require("./HighlightText");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-bind -- fixed */ // TODO: Fix accessibility issues with clickable div
const Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        borderBottom: "1px solid ".concat(theme.palette.divider),
        cursor: 'pointer',
        display: 'grid',
        gridTemplateAreas: "\n    'deliveryMethodTag'\n    'pickupPointInfo'\n    'shippingFee'\n    'additionalInfo'",
        padding: theme.spacing(3, 0),
        '&:last-child': {
            borderBottom: 0
        },
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'space-between',
            gridTemplateAreas: "\n    'deliveryMethodTag shippingFee'\n    'pickupPointInfo shippingFee'\n    'additionalInfo shippingFee'"
        }
    };
});
const PickupPointInfo = (0, _mui.styled)('div')({
    gridArea: 'pickupPointInfo',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
});
const DeliveryMethodTag = (0, _mui.styled)(_mui.Chip)((param)=>{
    let { theme } = param;
    return {
        gridArea: 'deliveryMethodTag',
        justifySelf: 'start',
        marginBottom: theme.spacing(2)
    };
});
const ShippingFee = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        fontWeight: 'bold',
        gridArea: 'shippingFee',
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(2, 0, 0)
        }
    };
});
const AdditionalInfo = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        gridArea: 'additionalInfo',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            margin: theme.spacing(2, 0, 0)
        }
    };
});
const StockIndicator = (0, _mui.styled)('span')((param)=>{
    let { ownerState: { isOutOfStock }, theme } = param;
    return {
        width: 8,
        height: 8,
        borderRadius: '50%',
        margin: theme.spacing(0, 1, 0, 3),
        backgroundColor: theme.palette.success.main,
        ...isOutOfStock && {
            backgroundColor: theme.palette.error.dark
        }
    };
});
const OutOfStockMessage = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        color: theme.palette.error.dark
    };
});
const InstantResultListRow = (param)=>{
    let { instantResultPickupPoint, searchTerm, selectInstantResult } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { display } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
    const { deliveryChannelId, deliveryMethod, estimatedDeliveryDate, outOfStockQuantity, shippingFee } = instantResultPickupPoint;
    const { deliveryChannelAddress } = (0, _useDeliveryChannelAddressQuery.useDeliveryChannelAddressQuery)(deliveryChannelId);
    const instantResultTestId = "".concat(_models.TestId.InstantResultListRow, "-").concat(deliveryChannelId);
    const isDescriptionDisplayed = display.includes(_models.PickupPointDisplayType.Description);
    const isOutOfStock = outOfStockQuantity > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        onClick: ()=>selectInstantResult(instantResultPickupPoint),
        ...getTestIdProps(instantResultTestId),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeliveryMethodTag, {
                variant: "tag",
                label: formatMessage((0, _utils.getDeliveryMethodTranslationKey)(deliveryMethod)),
                ...getTestIdProps("".concat(instantResultTestId, "-").concat(_models.TestId.DeliveryMethodTag))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickupPointInfo, {
                children: display.map((displayType)=>{
                    // TODO: Reduce complexity
                    const displayValue = (0, _utils.getPickupPointValueByDisplayOrder)(displayType, {
                        ...instantResultPickupPoint,
                        ...deliveryChannelAddress,
                        street: deliveryChannelAddress === null || deliveryChannelAddress === void 0 ? void 0 : deliveryChannelAddress.streetAddress,
                        zipCode: deliveryChannelAddress === null || deliveryChannelAddress === void 0 ? void 0 : deliveryChannelAddress.zipcode
                    });
                    const isCvId = displayType === _models.PickupPointDisplayType.CvId;
                    const isLabel = displayType === _models.PickupPointDisplayType.Description || isCvId && !isDescriptionDisplayed;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        style: {
                            fontWeight: isLabel ? 'bold' : undefined
                        },
                        children: [
                            displayValue && isCvId ? "".concat(formatMessage((0, _utils.getDeliveryMethodTranslationKey)(deliveryMethod)), ": ") : null,
                            displayValue ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_HighlightText.HighlightText, {
                                deliveryChannelId: deliveryChannelId,
                                searchTerm: searchTerm,
                                children: displayValue
                            }) : null
                        ]
                    }, "pickup-point-instruction-".concat(deliveryChannelId, "-").concat(displayType));
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShippingFee, {
                ...getTestIdProps("".concat(instantResultTestId, "-").concat(_models.TestId.ShippingFee)),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                    children: shippingFee
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AdditionalInfo, {
                children: [
                    estimatedDeliveryDate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        ...getTestIdProps("".concat(instantResultTestId, "-").concat(_models.TestId.EstimatedDelivery)),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_culture.FormatDate, {
                            value: estimatedDeliveryDate,
                            format: _culture.DateFormat.MonthDay
                        })
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StockIndicator, {
                        ownerState: {
                            isOutOfStock
                        }
                    }),
                    isOutOfStock ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(OutOfStockMessage, {
                        ...getTestIdProps("".concat(instantResultTestId, "-").concat(_models.TestId.OosFlag)),
                        children: [
                            outOfStockQuantity,
                            " ",
                            formatMessage('outOfStock')
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        children: formatMessage('allInStock')
                    })
                ]
            })
        ]
    });
};
exports.InstantResultListRow = InstantResultListRow;
